


















import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, DevicePriceType } from '@tt4b/ttam-enums';
import DevicePrice from './index';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-device-price-compose';
export default defineComponent({
  name,
  components: {
    TtamDevicePrice: DevicePrice.TtamDevicePrice,
    TtamDevicePriceRange: DevicePrice.TtamDevicePriceRange,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const minPriceInit = 0;
    const maxPriceInit = 50;
    const _deviceType = computed({
      get: () => adgroupData.value.deviceType,
      set: val => {
        if (val === DevicePriceType.RANGE) {
          emit('price-range-change', [minPriceInit, maxPriceInit]);
        } else {
          emit('price-range-change', []);
        }
        emit('device-type-change', val);
      },
    });
    const _launchPrice = computed({
      get: () => adgroupData.value.launchPrice,
      set: val => {
        emit('price-range-change', val);
      },
    });
    const { devicePriceValidator } = DevicePrice.useRules();
    const { priceRangeDisabled } = DevicePrice.usePriceRangePropsDisabled({ adgroupData, campaignData });
    const { devicePriceRangeVisible } = DevicePrice.useDevicePriceRangePropsVisible({ adgroupData });
    const { minOptions, maxOptions } = DevicePrice.useMinAndMaxOptions();

    const iconHoverTrack = () => trackEvent('create_adgroup_device_price_tips_hover');

    return {
      name,
      _deviceType,
      _launchPrice,
      devicePriceValidator,
      priceRangeDisabled,
      devicePriceRangeVisible,
      minOptions,
      maxOptions,
      iconHoverTrack,
    };
  },
});
